
// HA 설정
//
// @since 2018-08-3
// @author 강정규 ( devp012 )

export const state = () => ({
  url: '/api/sm/ha/config',
  urlMember: '/api/sm/ha/config/members',
  haMemberDataList: []
})

export const mutations = {
  getHaMemberDataList: (state, item) => {
    state.haMemberDataList = item
  },
  addHaMemberData: (state, item) => {
    state.haMemberDataList.push(item)
  },
  edtHaMemberData: (state, item) => {
    const idx = _.findIndex(state.haMemberDataList, {ha_mmbr_id: item.ha_mmbr_id})
    if (idx >= 0) {
      state.haMemberDataList.splice(idx, 1, item)
    }
  },
  delHaMemberData: (state, items) => {
    for (const item of items) {
      const idx = _.findIndex(state.haMemberDataList, {ha_mmbr_id: item.ha_mmbr_id})
      if (idx >= 0) {
        state.haMemberDataList.splice(idx, 1)
      }
    }
  }
}

export const actions = {
  async getHaMemberDataList ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.urlMember)
    if (code === 'ok') {
      commit('getHaMemberDataList', result)
      return true
    }
    return false
  },
  async addHaMemberData ({commit, state}, param) {
    const {code, result} = await this.$axios.$post(state.urlMember, param)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('addHaMemberData', result)
      return true
    }
    return false
  },
  async edtHaMemberData ({commit, state}, param) {
    const {code, result} = await this.$axios.$put(`${state.urlMember}/${param.ha_mmbr_id}`, param)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('edtHaMemberData', result)
      return true
    }
    return false
  },
  async delHaMemberData ({commit, state}, param) {
    if (param.idList.items.length === 1) {
      const data = await this.$axios.$delete(`${state.urlMember}/${param.idList.items[0].ha_mmbr_id}`)
      if (data.code === 'ok') {
        commit('delHaMemberData', param)
        this.dispatch(`common/common/setIsChanged`, true)
        return true
      }
      return false
    } else {
      const data = await this.$axios.$delete(state.url, {data: param.idList})
      if (data.code === 'ok') {
        commit('delHaMemberData', param)
        this.dispatch(`common/common/setIsChanged`, true)
      }
      return data
    }
  },
  async finalCommand ({commit, state}, type) {
    let param = {}
    if (type === 'apply') {
      param = { applyMsg: true }
    } else {
      param = { cancelMsg: true }
    }
    const {code} = await this.$axios.$put(`${state.url}/${type}`, null, param)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    }
    return false
  }
}

export const getters = {
  getTest () {
    return 1
  }
}

export const strict = false
